import CompactHeader from 'components/Header/CompactHeader/CompactHeader';

export default CompactHeader;
